import React from "react";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import * as ScreenText from "../../consts/ScreenText.js";

export default function PreviewButtons({ view, handleChange }) {
  return (
    <div>
      <Tabs
        value={view}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        centered
      >
        <Tab label={ScreenText.NOTIFICATION_PREVIEW_VIEW_TAG_INITIAL} />
        <Tab label={ScreenText.NOTIFICATION_PREVIEW_VIEW_TAG_EXPANDED} />
      </Tabs>
    </div>
  );
}
